import {
  FileText,
  FolderClosed,
  Globe,
  Home,
  ImageIcon,
  ListTodo,
  MessageCircle,
  Mic,
  Search,
  Sparkles,
  Telescope,
  Video,
} from "lucide-react";

// Navigation destinations. `live` sections work today; the rest are honest "Planned" pages.
// Research and Tasks are outside the launch scope: their pages and data are kept but not linked anywhere.
export const SECTIONS = {
  home: { label: "Home", path: "/", icon: Home, live: true },
  chats: { label: "Chats", path: "/chats", icon: MessageCircle, live: true, blurb: "Chat, Fast Search and Deep Search in one place" },
  projects: { label: "Projects", path: "/projects", icon: FolderClosed, live: true, blurb: "Keep your work organised and focused", description: "Group conversations, files and instructions into focused workspaces." },
  files: { label: "Files", path: "/files", icon: FileText, live: true, blurb: "Bring your documents into the conversation", description: "Upload documents and chat with them, with your files stored securely in your account." },
  research: { label: "Research", path: "/research", icon: Search, live: true, hidden: true },
  tasks: { label: "Tasks", path: "/tasks", icon: ListTodo, live: true, hidden: true },
  create: { label: "Create", path: "/create", icon: Sparkles, live: true, blurb: "Generate images and videos", description: "Generate and edit images and videos from a simple description." },
  voice: { label: "Voice", path: "/voice", icon: Mic, live: true, blurb: "Talk with JARVIS, your voice assistant", description: "Tap to talk with JARVIS and hear every answer spoken back, with a written transcript." },
};

export const NAV_ORDER = ["home", "chats", "projects", "files", "create", "voice"];

export const EXPLORE_ORDER = ["chats", "projects", "files", "create", "voice"];

export const QUICK_ACTIONS = [
  { key: "chat", label: "Chat", icon: MessageCircle, live: true },
  { key: "fast", label: "Fast Search", icon: Globe, live: true },
  { key: "deep", label: "Deep Search", icon: Telescope, live: true },
  { key: "image", label: "Image", icon: ImageIcon, note: "Image generation and editing." },
  { key: "video", label: "Video", icon: Video, note: "Video generation from a description." },
  { key: "voice", label: "Voice", icon: Mic, to: "/voice" },
];
